module.exports = __webpack_public_path__ + "img/search-icon.54cee3ef.svg";